import React from "react";

const FVFRWhyChoose = ({ title, description, reasons }) => {
  return (
    <section className="fvfr-why-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="row g-4">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="col-md-6"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="fvfr-why-card">
                <p className="fvfr-why-title">{reason.title}</p>
                <p className="fvfr-why-desc">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FVFRWhyChoose;
